import { DocumentType } from "../../interfaces/uploaded-file.interface";

export const getFileType = (mimeType: string): string => {
    const mimeMap: Record<string, string> = {
        "application/pdf": "PDF",
        "image/jpeg": "JPEG",
        "image/png": "PNG",
        "image/gif": "GIF",
        "text/plain": "Texto",
        "text/html": "HTML",
        "application/json": "JSON",
        "application/xml": "XML",
        "application/vnd.ms-excel": "Excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "Excel (XLSX)",
        "application/msword": "Word",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "Word (DOCX)",
        "application/zip": "ZIP",
        "application/x-rar-compressed": "RAR",
        "audio/mpeg": "MP3",
        "audio/wav": "WAV",
        "video/mp4": "MP4",
        "video/x-msvideo": "AVI",
    };
    return mimeMap[mimeType] || "Desconocido";
};

export const getFileExtension = (mimeType: string): string => {
    const mimeMap: Record<string, string> = {
        "application/pdf": ".pdf",
        "image/jpeg": ".jpg",
        "image/png": ".png",
        "image/gif": ".gif",
        "text/plain": ".txt",
        "text/html": ".html",
        "application/json": ".json",
        "application/xml": ".xml",
        "application/vnd.ms-excel": ".xls",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ".xlsx",
        "application/msword": ".doc",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ".docx",
        "application/zip": ".zip",
        "application/x-rar-compressed": ".rar",
        "audio/mpeg": ".mp3",
        "audio/wav": ".wav",
        "video/mp4": ".mp4",
        "video/x-msvideo": ".avi",
    };

    return mimeMap[mimeType] || "";
};


export const documentTypes: DocumentType[] = [
  { code: 1, value: 'DENUNCIA_CBU', label: 'CBU' },
  { code: 2, value: 'DENUNCIA_CONSTANCIACUILCUIT', label: 'Constancia de CUIL/CUIT' },
  { code: 3, value: 'DENUNCIA_DENUNCIAPOLICIAL', label: 'Denuncia Policial' },
  { code: 4, value: 'DENUNCIA_DNIFRENTE', label: 'DNI (Frente)' },
  { code: 5, value: 'DENUNCIA_DNIDORSO', label: 'DNI (Dorso)' },
  { code: 6, value: 'DENUNCIA_FACTURACOMPRA', label: 'Factura de Compra'  },
  { code: 7, value: 'DENUNCIA_REGISTROCONDUCIRFRENTE', label: 'Registro de Conducir (Frente)' },
  { code: 8, value: 'DENUNCIA_REGISTROCONDUCIRDORSO', label: 'Registro de Conducir (Dorso)' },
  { code: 9, value: 'DENUNCIA_TITULOPROPIEDAD', label: 'Título de Propiedad' },
  { code: 10, value: 'DENUNCIA_TITULOCEDULAVERDEFRENTE', label: 'Título o Cédula Verde (Frente)' },
  { code: 11, value: 'DENUNCIA_TITULOCEDULAVERDEDORSO', label: 'Título o Cédula Verde (Dorso)' },
  { code: 12, value: 'Denuncia', label: 'Denuncia'  },
  { code: 13, value: 'OrdenReposicion_Denuncia', label: 'Denuncia Orden Reposición' },
  { code: 14, value: 'DENUNCIA_FOTOVEHICULO_1', label: 'Foto del Vehículo 1' },
  { code: 14, value: 'DENUNCIA_FOTOVEHICULO_2', label: 'Foto del Vehículo 2' },
  { code: 14, value: 'DENUNCIA_FOTOVEHICULO_3', label: 'Foto del Vehículo 3' },
  { code: 14, value: 'DENUNCIA_FOTOVEHICULO_4', label: 'Foto del Vehículo 4' },
];

export const documentTypesRV: DocumentType[] = [
  { code: 1, value: 'DENUNCIA_CBU', label: 'CBU' },
  { code: 2, value: 'DENUNCIA_CONSTANCIACUILCUIT', label: 'Constancia de CUIL/CUIT' },
  { code: 3, value: 'DENUNCIA_DENUNCIAPOLICIAL', label: 'Denuncia Policial' },
  { code: 4, value: 'DENUNCIA_DNIFRENTE', label: 'DNI (Frente) Asegurado' },
  { code: 5, value: 'DENUNCIA_DNIDORSO', label: 'DNI (Dorso) Asegurado' },
  { code: 6, value: 'DENUNCIA_FACTURACOMPRA', label: 'Factura de Compra' },
  { code: 12, value: 'Denuncia', label: 'Denuncia' },

  { code: 14, value: 'DENUNCIA_FOTOSINIESTRO_1', label: 'Foto del Siniestro 1' },
  { code: 14, value: 'DENUNCIA_FOTOSINIESTRO_2', label: 'Foto del Siniestro 2' },
  { code: 14, value: 'DENUNCIA_FOTOSINIESTRO_3', label: 'Foto del Siniestro 3' },
  { code: 14, value: 'DENUNCIA_FOTOSINIESTRO_4', label: 'Foto del Siniestro 4' },

  { code: 96, value: 'DENUNCIA_ACTAADMINISTRADOR', label: 'Acta del Administrador' },
  { code: 17, value: 'DENUNCIA_AMPLIACIONES', label: 'Ampliaciones de Denuncias por motivos diversos' },
  { code: 25, value: 'DENUNCIA_CARTADOCUMENTO', label: 'Carta Documento' },
  { code: 97, value: 'DENUNCIA_CERTIFICADOMEDICO', label: 'Certificado Médico' },
  { code: 32, value: 'DENUNCIA_CONSTANCIABOMBEROS', label: 'Constancia de Actuación de Bomberos' },
  { code: 98, value: 'DENUNCIA_ESTATUTOCONSORCIO', label: 'Copia Estatuto Consorcio' },
  { code: 99, value: 'DENUNCIA_ESTATUTOSOCIETARIO', label: 'Copia Estatuto Societario' },
  { code: 70, value: 'DENUNCIA_INFORMETECNICO', label: 'Informe Técnico' },
  { code: 100, value: 'DENUNCIA_OTROS', label: 'Otros' },
  { code: 101, value: 'DENUNCIA_PREEXISTENCIAS', label: 'Pre-existencias' },
  { code: 102, value: 'DENUNCIA_PRESUPUESTOS', label: 'Presupuestos' },
  { code: 103, value: 'DENUNCIA_TITULARIDADDOMINIAL', label: 'Titularidad Dominial' },
  { code: 36, value: 'POLIZA_DENUNCIA', label: 'Consulta De Póliza' }
];